import { render } from "./LoginForm.vue?vue&type=template&id=7f98e6f7&ts=true"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__